import React from 'react';
import Icon from '../../libraries/icons';
import { uuidv4, capitalize } from '../../libraries/utils';
import { useTranslation } from 'react-i18next';
import Avatar from '../../components/commons/Avatar';
import config from "../../config";


export default function ProfessionalElement({ professional, points, left, ...rest }) {
  const { t, i18n } = useTranslation();  
  const { first_name, last_name, specialty, address, horario } = professional.json_data;
  const { profile_image, username, accessibility } = professional;
  return (
    <div key={rest.key || uuidv4()}>
      <div className="flex">
        <Avatar
          image={profile_image}
          label={username}
          className="rounded-full w-16 h-16"
          containerClassName="mr-3"
        />
        <div className="flex flex-auto justify-between">
          <div className="pr-2 leading-tight">
            {first_name && last_name && (
              <h3 className="text-primary">{capitalize(first_name)} {capitalize(last_name)}</h3>
            )}
            {specialty && (
              <small>{capitalize(specialty)}</small>
            )}
            <div className="mt-2">
              <small className="text-gray-400 mr-2">Disponible en: </small>
              {accessibility && accessibility.appointments ? 
                (<>
                  <Icon className={"w-5 mr-1 inline-block " + (accessibility.appointments.includes(config.TRANSACTIONS.BOOK.SUB_TYPE.VIDEO) ? "text-success" : "text-gray-300")} name="video_camera" />
                  <Icon className={"w-5 mr-1 inline-block " + (accessibility.appointments.includes(config.TRANSACTIONS.BOOK.SUB_TYPE.VISIT) ? "text-success" : "text-gray-300")} name="door" />
                </>) :
                (<>
                  <Icon className={"w-5 mr-1 inline-block text-gray-300"} name="video_camera" />
                  <Icon className={"w-5 mr-1 inline-block text-gray-300"} name="door" />
                </>)
              }
            </div>
          </div>  
          <small className="text-gray-500"> <Icon className="h-4 w-4 inline-block" name="location_marker" /> 1,5 km </small>
        </div>
      </div>
    </div>
  )
}